import { createUseStyles } from 'react-jss'

import { colors, desktop, notDesktop } from '../../theme'


export const variants = {
  Transparent: 'transparent',
  BigTransparent: 'bigtransparent',
  BigWhite: 'bigwhite',
}

export const theming = {
  container: {
    padding: {
      [variants.Transparent]: '0.6rem 1rem 0.4rem',
      [variants.BigTransparent]: '1rem 1rem 0.6rem',
      [variants.BigWhite]: '1rem 1rem 0.6rem',
    },
    backgroundColor: {
      [variants.Transparent]: 'none',
      [variants.BigTransparent]: 'none',
      [variants.BigWhite]: colors.pureWhite,
    },
    color: {
      [variants.Transparent]: colors.pureWhite,
      [variants.BigTransparent]: colors.pureWhite,
      [variants.BigWhite]: colors.pureBlack,
    },
  },
}

export default createUseStyles({
  container: {
    position: 'relative',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: (props) => theming.container.padding[props.variant],
    border: `1px solid ${colors.pureWhite}`,
    borderRadius: '0.8rem',
    color: (props) => theming.container.color[props.variant],
    fontSize: '1.2rem',
    lineHeight: '1.2',
    textTransform: 'uppercase',
    textAlign: 'center',
    backgroundColor: (props) => (theming.container.backgroundColor[props.variant]
      ? theming.container.backgroundColor[props.variant]
      : colors.pureBlack),
    transition: 'all 300ms ease-in-out',
    ...notDesktop({
      '@media (hover: hover)': {
        '&:hover': {
          color: colors.pureBlack,
          backgroundColor: colors.pureWhite,
        },
      },
    }),
    ...desktop({
      '&:hover': {
        color: `${colors.pureBlack} !important`,
        backgroundColor: `${colors.pureWhite} !important`,
      },
    }),
  },
  textContainer: {},
  text: {},
})
